export default "__VITE_ASSET__COdibvN0__"